module.exports = __webpack_public_path__ + "static/wtl-logo-447f8efad0e055e0ebb06ffac87a4c10.png";